import React from 'react';
import classNames from 'classnames';
import nowLogo from '../../assets/images/now-logo.png';
import { resolveCategoryIcon } from '../../util/categoryIcon';
import css from './CategoryIcon.module.css';

/**
 * Renders a category/subcategory icon: its own uploaded icon, else its
 * parent's, else the NOW logo. Replaces the old raw-emoji-text rendering
 * (categories.iconUrl used to hold an emoji glyph; now it holds an image
 * URL or nothing).
 */
const CategoryIcon = props => {
  const { category, parent, className } = props;
  const resolved = resolveCategoryIcon(category, parent);

  return (
    <span className={classNames(css.root, className)} aria-hidden="true">
      <img src={resolved || nowLogo} alt="" className={css.image} />
    </span>
  );
};

export default CategoryIcon;
